import { Component, type ErrorInfo, type ReactNode } from 'react'
import { AlertTriangle, RotateCcw } from 'lucide-react'

type Props = { children: ReactNode }
type State = { error: Error | null }

export class AdminErrorBoundary extends Component<Props, State> {
  state: State = { error: null }

  static getDerivedStateFromError(error: Error): State {
    return { error }
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('[clyr admin] page crashed', error, info.componentStack)
  }

  render() {
    if (!this.state.error) return this.props.children
    return (
      <section className="admin-error-state" role="alert">
        <AlertTriangle aria-hidden="true" />
        <div>
          <h1>This admin page hit a problem</h1>
          <p>Your action was not completed. Reload this page and try again; no data was removed.</p>
          <button type="button" onClick={() => window.location.reload()}>
            <RotateCcw aria-hidden="true" /> Reload page
          </button>
        </div>
      </section>
    )
  }
}
